import axios from 'axios';

const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class FulfillmentService {
  async create(authToken, payload) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.post(
        API_URL +
          `/Inventory/Requests/${payload.inventoryRequestId}/Fulfillments`,
        payload.data,
        {
          headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
  async backOrderFulfillment(authToken, payload) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.post(
        API_URL + `/BackOrders/${payload.inventoryRequestId}/Fulfillments`,
        payload.data,
        {
          headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
  async backOrderFulfillments(authToken, payload) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.get(
        API_URL +
          `/BackOrders/Fulfillments?BackOrderId=${payload.backOrderId}&Limit=${payload.limit}`,
        {
          headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
  async fulfillments(authToken, payload) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.get(
        API_URL +
          `/Inventory/Fulfillments?requestId=${payload.sourceLocationId}&limit=${payload.limit}`,
        {
          headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
  async status(authToken, payload) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.patch(
        API_URL + `/Inventory/Fulfillments/${payload.fulfillmentId}`,
        payload.data,
        {
          headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
  async backOrderStatus(authToken, payload) {
    let headers = {
      Authorization: `${authToken}`,
    };
    try {
      const response = await axios.patch(
        API_URL + `/BackOrders/Fulfillments/${payload.fulfillmentId}`,
        payload.data,
        {
          headers,
        }
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }
}
export default new FulfillmentService();
